import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import Clients from "../pages/Clients";
import Discount from "../pages/Discount";
import Modification from "../pages/Modification";
import Products from "../pages/Products";
import Sales from "../pages/Sales";
import Orders from "../pages/Orders";
import PrivateRoute from "../Private/PrivateRoute";
import PublicRoute from "../Private/PublicRoute";
import Unauthorized from "../pages/Unauthorized";
import NotFound from "../pages/NotFound";
import Home from "../pages/Home";
import Otp from "../pages/Otp";
import PendingClients from "../pages/PendingClients";
import Profile from "../pages/Profile";
import ForgotPassword from "../pages/ForgotPassword";
import OrderDetails from "../pages/OrderDetails";
import AccountBlock from "../pages/AccountBlock";
import CheckOut from "../pages/CheckOut";
import ProductNewlyAdded from "../pages/ProductNewlyAdded";
import ProductBestSeller from "../pages/ProductBestSeller";
import ProductFavorites from "../pages/ProductFavorites";
import ProductDetails from "../pages/ProductDetails";
import Stocks from "../pages/Stocks";
import Shades from "../pages/Shades";
import Notification from "../pages/Notification";
import { roleIds } from "../constant";
import {
  PiBookOpenFill,
  PiBriefcaseFill,
  PiFadersHorizontalFill,
  PiMegaphoneFill,
  PiPackage,
  PiPackageFill,
  PiToolboxFill,
} from "react-icons/pi";
import { MdMenuBook } from "react-icons/md";
import { RiDiscountPercentFill, RiHome5Fill } from "react-icons/ri";
import { HiUsers } from "react-icons/hi2";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndCondtions";
import { useSelector } from "react-redux";
import SignUp from "../pages/customer/SignUp";
import CustomerOrders from "../pages/customer/CustomerOrders";
import CustomerProducts from "../pages/customer/CustomerProducts";
import Users from "../pages/admin/Users";
import Announcements from "../pages/admin/Announcements";
import NewlyAddedProducts from "../pages/customer/NewlyAddedProducts";
import AllStock from "../pages/AllStock";
import CategoryProducts from "../pages/customer/CategoryProducts";
import SchemeDetails from "../pages/customer/SchemeDetails";
import SchemeRequestList from "../pages/SchemeRequestList";
import AdminSchemeDetails from "../pages/AdminSchemeDetails";
import AllFoldings from "../pages/AllFoldings";
import AllGreys from "../pages/AllGreys";

export const useAllRoutes = () => {
  const { role_id } = useSelector((state) => state.auth);

  const commonRoutes = [
    { path: "/", element: <Home />, roles: Object.values(roleIds) },
    // Customer Routes
    {
      path: "/login",
      element: <Login pageType="customer" />,
    },
    {
      path: "/signup",
      element: <SignUp />,
    },
    { path: "/otp-verify", element: <Otp pageType="customer" /> },
    {
      path: "/forgot-password",
      element: <ForgotPassword pageType="customer" />,
    },

    // sales Routes
    { path: "/sales/login", element: <Login /> },
    { path: "/sales/otp-verify", element: <Otp /> },
    { path: "/sales/forgot-password", element: <ForgotPassword /> },
    { path: "/sales", element: <Home /> },
    // Admin Routes
    { path: "/admin/login", element: <Login pageType="admin" /> },
    { path: "/admin/otp-verify", element: <Otp pageType="admin" /> },
    {
      path: "/admin/forgot-password",
      element: <ForgotPassword pageType="admin" />,
    },
    { path: "/admin", element: <Home /> },
    {
      path: "/account-block",
      element: <AccountBlock />,
      roles: Object.values(roleIds),
      showMainLayout: false,
    },
    {
      path: "/unauthorized",
      element: <Unauthorized />,
      roles: Object.values(roleIds),
      showMainLayout: false,
    },
  ];

  const salesRoutes = [
    // Private Routes
    {
      path: "/sales/dashboard",
      element: <Dashboard />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      sidebar: {
        icon: RiHome5Fill,
        label: "Home",
      },
    },

    {
      path: "/sales/orders",
      element: <Orders />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      sidebar: {
        icon: PiPackageFill,
        label: "Orders",
        additionalPaths: ["orders"],
      },
    },
    {
      path: "/sales/clients",
      element: <Clients />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      sidebar: {
        icon: HiUsers,
        label: "Clients",
        additionalPaths: ["pending-clients", "client-profile"],
      },
    },
    {
      path: "/sales/sales-employees",
      element: <Sales />,
      roles: [roleIds.SalesManager],
      sidebar: {
        icon: PiBriefcaseFill,
        label: "Sales Employees",
        additionalPaths: ["sales-profile"],
      },
    },
    {
      path: "/sales/pending-clients",
      element: <PendingClients />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/orders/:id",
      element: <OrderDetails />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },

    {
      path: "/sales/product-catalog",
      element: <Products />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      sidebar: {
        icon: PiBookOpenFill,
        label: "Catalogue",
        additionalPaths: ["product-details", "product-catalog"],
      },
    },
    {
      path: "/sales/discount-schemes",
      element: <Discount />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      sidebar: {
        icon: RiDiscountPercentFill,
        label: "Discounts",
        additionalPaths: ["scheme-requests", "scheme-details"],
      },
    },
    {
      path: "/sales/scheme-requests",
      element: <SchemeRequestList />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },

    {
      path: "/sales/scheme-details",
      element: <AdminSchemeDetails />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/modifications",
      element: <Modification />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      sidebar: {
        icon: PiFadersHorizontalFill,
        label: "Modifications",
        additionalPaths: ["modification-profile"],
      },
    },

    {
      path: "/sales/product-details/:sort_no",
      element: <ProductDetails />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/now-trending",
      element: <ProductNewlyAdded />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/top-selling",
      element: <ProductBestSeller />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/favorites",
      element: <ProductFavorites />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/checkout",
      element: <CheckOut />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/stocks",
      element: <Stocks />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },

    {
      path: "/sales/product-catalog/all-stocks",
      element: <AllStock />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/folding",
      element: <AllFoldings />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/grey",
      element: <AllGreys />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/product-catalog/shades",
      element: <Shades />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/profile",
      element: <Profile />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/client-profile",
      element: <Profile />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/sales-profile",
      element: <Profile />,
      roles: [roleIds.SalesManager],
    },
    {
      path: "/sales/modification-profile",
      element: <Profile />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
    },
    {
      path: "/sales/notification",
      element: <Notification />,
      roles: [roleIds.SalesManager, roleIds.SalesPerson],
      ignoreNotificationRefresh: true,
    },
  ];

  const customerRoutes = [
    {
      path: "/product-catalog",
      element: <CustomerProducts />,
      roles: [roleIds.Customer],
    },
    {
      path: "/product-details/:sort_no",
      element: <ProductDetails />,
      roles: [roleIds.Customer],
    },
    {
      path: "/orders",
      element: <CustomerOrders />,
      roles: [roleIds.Customer],
    },
    {
      path: "/orders/:id",
      element: <OrderDetails />,
      roles: [roleIds.Customer],
    },
    {
      path: "/profile",
      element: <Profile />,
      roles: [roleIds.Customer],
    },
    {
      path: "/notification",
      element: <Notification />,
      roles: [roleIds.Customer],
    },
    {
      path: "/product-catalog/checkout",
      element: <CheckOut />,
      roles: [roleIds.Customer],
    },
    {
      path: "/home/:type",
      element: <NewlyAddedProducts />,
      roles: [roleIds.Customer],
    },

    {
      path: "/home/category/:category",
      element: <CategoryProducts />,
      roles: [roleIds.Customer],
    },

    {
      path: "/home/scheme-details",
      element: <SchemeDetails />,
      roles: [roleIds.Customer],
    },
  ];

  const adminRoutes = [
    {
      path: "/admin/dashboard",
      element: <Dashboard />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: RiHome5Fill,
        label: "Home",
      },
    },
    {
      path: "/admin/users",
      element: <Users />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: HiUsers,
        label: "Users",
        additionalPaths: [
          "user-profile",
          "client-profile",
          "customers",
          "pending-clients",
        ],
      },
    },
    {
      path: "/admin/customers",
      element: <Clients />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/pending-clients",
      element: <PendingClients />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/client-profile",
      element: <Profile />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/user-profile",
      element: <Profile />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/profile",
      element: <Profile />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/notification",
      element: <Notification />,
      roles: [roleIds.Admin],
      ignoreNotificationRefresh: true,
    },

    {
      path: "/admin/announcements",
      element: <Announcements />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: PiMegaphoneFill,
        label: "Announcements",
      },
    },
    {
      path: "/admin/product-catalog",
      element: <Products />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: PiBookOpenFill,
        label: "Catalogue",
        additionalPaths: ["product-details", "product-catalog"],
      },
    },
    {
      path: "/admin/product-details/:sort_no",
      element: <ProductDetails />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/now-trending",
      element: <ProductNewlyAdded />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/top-selling",
      element: <ProductBestSeller />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/favorites",
      element: <ProductFavorites />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/checkout",
      element: <CheckOut />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/stocks",
      element: <Stocks />,
      roles: [roleIds.Admin],
    },

    {
      path: "/admin/product-catalog/all-stocks",
      element: <AllStock />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/folding",
      element: <AllFoldings />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/grey",
      element: <AllGreys />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/product-catalog/shades",
      element: <Shades />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/orders",
      element: <Orders />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: PiPackageFill,
        label: "Orders",
        additionalPaths: ["orders"],
      },
    },
    {
      path: "/admin/orders/:id",
      element: <OrderDetails />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/discount-schemes",
      element: <Discount />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: RiDiscountPercentFill,
        label: "Discounts",
        additionalPaths: ["scheme-requests", "scheme-details"],
      },
    },

    {
      path: "/admin/scheme-requests",
      element: <SchemeRequestList />,
      roles: [roleIds.Admin],
    },

    {
      path: "/admin/scheme-details",
      element: <AdminSchemeDetails />,
      roles: [roleIds.Admin],
    },
    {
      path: "/admin/modifications",
      element: <Modification />,
      roles: [roleIds.Admin],
      sidebar: {
        icon: PiFadersHorizontalFill,
        label: "Modifications",
        additionalPaths: ["modification-profile"],
      },
    },
    {
      path: "/admin/modification-profile",
      element: <Profile />,
      roles: [roleIds.Admin],
    },
  ];

  const allRoutes = commonRoutes;

  switch (role_id) {
    case roleIds.SalesPerson:
    case roleIds.SalesManager:
      allRoutes.push(...salesRoutes);
      break;

    case roleIds.Customer:
      allRoutes.push(...customerRoutes);
      break;

    case roleIds.Admin:
      allRoutes.push(...adminRoutes);
      break;

    default:
      break;
  }

  return allRoutes;
};

const AppRoutes = () => {
  const allRoutes = useAllRoutes();
  const [privateRoutes, publicRoutes] = [
    allRoutes.filter((route) => route.roles),
    allRoutes.filter((route) => !route.roles),
  ];
  return (
    <>
      <Routes>
        {/* Private Routes with per-route role-based access */}
        {privateRoutes.map(({ path, element, roles, showMainLayout }) => (
          <Route
            element={
              <PrivateRoute role={roles} showMainLayout={showMainLayout} />
            }
          >
            <Route path={path} element={element} />
          </Route>
        ))}

        {/* public routes */}
        {publicRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<PublicRoute>{element}</PublicRoute>}
          />
        ))}

        {/* static routes */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
